import React from 'react';
import { number } from 'prop-types';

export function Plus({ size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 12 12">
      <path id="a" d="M7 5V0H5v5H0v2h5v5h2V7h5V5z" />
    </svg>
  );
}

Plus.displayName = 'Plus';
Plus.propTypes = {
  size: number,
};
Plus.defaultProps = {
  size: 12,
};

export function Minus({ size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 12 2">
      <path d="M0 0h12v2H0z" />
    </svg>
  );
}

Minus.displayName = 'Minus';
Minus.propTypes = {
  size: number,
};
Minus.defaultProps = {
  size: 12,
};

export function Delete({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" transform="rotate(45)">
      <path id="a" d="M7 5V0H5v5H0v2h5v5h2V7h5V5z" />
    </svg>
  );
}

Delete.displayName = 'Delete';
Delete.propTypes = {
  size: number,
};
Delete.defaultProps = {
  size: 12,
};
